<!-- Footer section -->
<footer>
  <div class="container-fluid">
    <div
      class="mw-footer-container px-3 py-0 text-bg-light border-bottom fixed-bottom d-flex justify-content-end align-items-center"
      [ngClass]="{
        'login-footer': isLoginPage,
        'manage-footer': isManagePage,
        'desktop': !isMobile && isLoginPage
      }"
    >
      <!-- Main column with copyright information -->
        <div class="footer-text-container position-absolute start-50 translate-middle-x text-center">
          <p class="text-body-primary font m-0">&copy; {{ currentYear }} Nova Global <span class="version">V-2.1.1</span></p>
        </div>
      <!-- Right column (empty for now) -->
      <div class="column-right font">
        <label
        class="sr-only"
        for="language"
        >
          {{ 'buttonText' | translate }}
        </label>
          <select
            [(ngModel)]="selectedLanguage"
            (click)="onMouseInteraction($event)"
            (keydown)="onKeyboardInteraction($event)"
            [ngClass]="theme.getThemeClass()"
            class="language-select font"
            id="language"
          >
            <option class="font" value="fr" selected>FR</option>
            <option class="font" value="en">EN</option>
            <option class="font" value="es">ES</option>
          </select>
      </div>
    </div>
  </div>
</footer>
